import { render, staticRenderFns } from "./DrawerFilterCollection.vue?vue&type=template&id=464bb68a"
import script from "./DrawerFilterCollection.vue?vue&type=script&lang=js"
export * from "./DrawerFilterCollection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports